import React, { useState, useEffect } from 'react';
import { obtenerProductos, crearProducto, actualizarProducto, eliminarProducto } from '../../../../services/productosService';
import ProductTable from './ProductTable';
import ProductForm from './ProductForm';
import toast from 'react-hot-toast';

/**
 * Componente principal de gestión de productos
 * Maneja el ABM completo de productos
 */
const ProductManagement = () => {
  const [productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);

  useEffect(() => {
    cargarProductos();
  }, []);

  const cargarProductos = async () => {
    try {
      setLoading(true);
      const data = await obtenerProductos();
      setProductos(data);
    } catch (error) {
      toast.error('Error al cargar productos');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = () => {
    setEditingProduct(null);
    setShowForm(true);
  };

  const handleEdit = (producto) => {
    setEditingProduct(producto);
    setShowForm(true);
  };

  const handleDelete = async (producto) => {
    if (window.confirm(`¿Estás seguro de eliminar "${producto.nombre}"?`)) {
      try {
        await eliminarProducto(producto.id);
        toast.success('Producto eliminado correctamente');
        cargarProductos();
      } catch (error) {
        toast.error('Error al eliminar producto');
        console.error(error);
      }
    }
  };

  const handleFormSubmit = async (formData) => {
    try {
      if (formData.id) {
        // Actualizar producto existente
        await actualizarProducto(formData.id, formData);
        toast.success('Producto actualizado correctamente');
      } else {
        // Crear nuevo producto
        await crearProducto(formData);
        toast.success('Producto creado correctamente');
      }
      setShowForm(false);
      setEditingProduct(null);
      cargarProductos();
    } catch (error) {
      toast.error('Error al guardar producto');
      console.error(error);
    }
  };

  const handleFormCancel = () => {
    setShowForm(false);
    setEditingProduct(null);
  };

  if (loading) {
    return <div className="text-center py-8">Cargando productos...</div>;
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold text-gray-900">
          Gestión de Productos
        </h2>
        <button
          onClick={handleCreate}
          className="px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700"
        >
          + Nuevo Producto
        </button>
      </div>

      {showForm ? (
        <div className="bg-white shadow rounded-lg p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">
            {editingProduct ? 'Editar Producto' : 'Nuevo Producto'}
          </h3>
          <ProductForm
            producto={editingProduct}
            onSubmit={handleFormSubmit}
            onCancel={handleFormCancel}
          />
        </div>
      ) : (
        <div className="bg-white shadow rounded-lg">
          {productos.length === 0 ? (
            <div className="text-center py-8 text-gray-500">
              No hay productos registrados
            </div>
          ) : (
            <ProductTable
              productos={productos}
              onEdit={handleEdit}
              onDelete={handleDelete}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default ProductManagement;
